export default "__VITE_ASSET__BkOfpbAS__"